import { useNostr } from '@nostrify/react';
import { useQuery } from '@tanstack/react-query';
import type { NostrEvent } from '@nostrify/nostrify';

interface ReactionCount {
  emoji: string;
  count: number;
}

/**
 * Hook to fetch reactions for a specific color moment
 */
export function useMomentReactions(eventId: string) {
  const { nostr } = useNostr();

  return useQuery({
    queryKey: ['moment-reactions', eventId],
    queryFn: async () => {
      const reactions = await nostr.query([
        {
          kinds: [7],
          '#e': [eventId],
          limit: 200,
        },
      ]);

      // Count reactions by emoji
      const counts = new Map<string, number>();
      
      reactions.forEach((reaction: NostrEvent) => {
        const emoji = reaction.content.trim();
        if (emoji) {
          counts.set(emoji, (counts.get(emoji) || 0) + 1);
        }
      });

      // Convert to array and sort by count
      const reactionCounts: ReactionCount[] = Array.from(counts.entries())
        .map(([emoji, count]) => ({ emoji, count }))
        .sort((a, b) => b.count - a.count);

      return reactionCounts;
    },
  });
}
